// A Custom board in small, for its tile in All boards: a row of choices over its records, one line each. The app is
// the agent's own code and is not drawn here; the shape says what the board is, and the records say how full it is.

import { recordsOf } from "../../../shared/records";
import type { Board, Entry } from "../../../shared/types";
import "../../styles/custom-board.css";

export function CustomThumb({ entries }: { board: Board; entries: Entry[] }) {
  const rows = recordsOf(entries).slice(-5);
  return (
    <div className="ov-cu">
      <div className="ov-cu-panel">
        <span className="ov-cu-chips">
          <i className="is-on" />
          <i />
          <i />
        </span>
        {(rows.length ? rows : [null, null, null]).map((r, n) => (
          <span key={r?.id ?? n} className="ov-cu-row">
            <i style={{ width: `${r ? 30 + (JSON.stringify(r.data).length % 40) : 40 - n * 6}%` }} />
            <b />
          </span>
        ))}
      </div>
    </div>
  );
}
